import {useCallback} from 'react';
import {useLocalStorageContext} from './context';

interface IUseLocalStorageReturn {
    localStorage: Record<string, any>;
    getItem: (key?: string) => any;
    setItem: (value: any) => void;
    setItemWithKey: (key: string, value: any) => void;
    removeItem: (key?: string) => void;
}

const useLocalStorage = (key?: string): IUseLocalStorageReturn => {
    const {getItem: _getItem, setItem: _setItem, removeItem: _removeItem, localStorage} = useLocalStorageContext();

    const getItem = useCallback(
        (_key?: string) => {
            return _getItem(key || _key || '');
        },
        [_getItem, key]
    );

    const setItem = useCallback(
        (value: any) => {
            return _setItem({key: key || '', value});
        },
        [_setItem, key]
    );

    const setItemWithKey = useCallback(
        (_key: string, value: any) => {
            return _setItem({key: key || _key, value});
        },
        [_setItem, key]
    );

    const removeItem = useCallback(
        (_key?: string) => {
            return _removeItem(key || _key || '');
        },
        [_removeItem, key]
    );

    return {getItem, setItem, removeItem, setItemWithKey, localStorage};
};

export default useLocalStorage;
